
import {
  defineComponent,
  getCurrentInstance,
  nextTick,
  onMounted,
  reactive,
  toRefs,
} from "vue";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import { Search, TreeSelect, Popup, Checkbox, Toast } from "vant";
import {
  getUserInfo,
  parseImgUrl,
  setLocalProjectId,
  setQueryConfig,
} from "@/utils";
import { store } from "@/store";
import { UserMutationTypes } from "@/store/modules/user/mutation-types";
import {
  checkWorkSpace,
  deleteWorkSpace,
  getBuildingList,
  getDefaultLocation,
  getFloorList,
  getPadSpaceList,
  insertWorkSpace,
  queryWorkSpace,
  saveWorkSpace,
} from "@/apis/envmonitor";
import { clear } from "console";

export default defineComponent({
  components: {
    vanSearch: Search,
    VanPopup: Popup,
    VanTreeSelect: TreeSelect,
    VanCheckbox: Checkbox,
  },
  setup() {
    const proxyGlobal: any = getCurrentInstance();
    const route: any = useRoute();
    const router: any = useRouter();
    const userInfo: any = getUserInfo();
    const option1 = [
      { text: "全部商ddddd品", value: 0 },
      { text: "新款商ddd品", value: 1 },
      { text: "活动商ddd品", value: 2 },
    ];
    const option2 = [
      { text: "默认排序", value: "a" },
      { text: "好评排ddd序", value: "b" },
      { text: "销量排序", value: "c" },
    ];
    let positionArr: any = [];
    let checkPositon: any = {
      buildingName:''
    };
    const defaultSpaceData: any = {};
    const buildingData: any = [];
    const buildingItem: any = {};
    const floorData: any = [];
    const spaceTypeArr: any = [
      {
        type: "",
        name: "全部空间",
      },
      {
        type: 0,
        name: "个人办公室",
      },
      {
        type: 1,
        name: "开放办公区",
      },
      {
        type: 2,
        name: "会议室",
      },
      {
        type: 99,
        name: "其它",
      },
    ];
    const spaceType: any = {
      type: "",
      name: "全部空间",
    };
    const spaceData: any = [];
    const copySpaceData: any = [];
    const proxyData = reactive({
      parseImgUrl: parseImgUrl,
      showSpace: true,
      userInfo: userInfo,
      activeIndex: 0,
      spaceType: spaceType,
      searchSpaceName: "",
      checked: false,
      positionArr: positionArr,
      checkPositon: checkPositon,
      route: route,
      option1: option1,
      option2: option2,
      value1: 0,
      value2: "a",
      transitionName: "slide-right",
      showHeader: false,
      showSpaceType: false,
      show: false, // 是否展示选择建筑的页面
      spaceTypeArr: spaceTypeArr,
      showPounp() {
        proxyData.show = !proxyData.show;
      },
      showSpaceTypePounp() {
        proxyData.showSpaceType = !proxyData.showSpaceType;
      },
      // 选择空间
      checkSpaceType(item: any) {
        proxyData.spaceType = item;
        proxyData.showSpaceType = false;
        // 获取空间列表
        proxyData.searchSpace();
      },
      buildingData: buildingData,
      buildingItem: buildingItem,
      // 获取建筑列表
      getBuildingList() {
        let params: any = {
          criteria: {
            projectId: proxyData.userInfo.projectId, //类型：String  必有字段  备注：项目id
          },
        };
        getBuildingList(params).then((res) => {
          let resData: any = res;
          if (resData.result === "success") {
            let content: any = resData?.content ?? [];
            proxyData.buildingData = content;
            proxyData.setBbuildingName();
            proxyData.getFloorList();
          } else {
            proxyData.buildingData = [];
          }
        });
      },
      //  设置建筑名称
      setBbuildingName() {
        proxyData.buildingData.map((item: any, index: any) => {
          if (item.id === proxyData.checkPositon.buildingId) {
            proxyData.checkPositon.buildingName = item.localName;
            proxyData.activeIndex = index;
          }
        });
      },
      // 格式化建筑数据
      formateBuildingData() {
        // debugger
        proxyData.positionArr = [];
        for (let i = 0; i < proxyData.buildingData.length; i++) {
          let obj = {
            text: proxyData.buildingData[i].localName,
            id: proxyData.buildingData[i].id,
            children: [],
          };
          if (
            proxyData.buildingData[i].id === proxyData.checkPositon.buildingId
          ) {
            proxyData.activeIndex = i;
            proxyData.floorData.map((item: any) => {
              item.text = item.localName;
              if (item.id === proxyData.checkPositon.floorId) {
                proxyData.checkPositon.floorName = item.localName;
              }
            });
            proxyData.checkPositon.buildingName =
              proxyData.buildingData[i].localName;
            obj.children = proxyData.floorData;
          }
          // debugger
          console.log(proxyData.floorData);
          proxyData.positionArr.push(obj);
        }
        console.log(proxyData.positionArr);
      },
      floorData: floorData,
      /**
       * 查询楼层信息
       */
      getFloorList() {
        if (proxyData.checkPositon.buildingId) {
          let params: any = {
            criteria: {
              projectId: proxyData.userInfo.projectId,
              buildingId: proxyData.checkPositon.buildingId,
            },
            orders: [
              {
                asc: true,
                column: "localId",
              },
            ],
          };
          getFloorList(params)
            .then((res) => {
              let resData: any = res;
              if (res.result === "success") {
                proxyData.floorData = resData?.content ?? [];
              } else {
                proxyData.floorData = [];
              }
              proxyData.formateBuildingData();
              proxyData.getPadSpaceList();
              // console.log(proxyData.floorData);
            })
            .catch(() => {});
        }
      },
      // 平板默认 空间
      defaultSpaceData: defaultSpaceData,
      // 查询当前平板的默认空间await与wait的区别
      getDefaultLocation() {
        let params: any = {
          macAddress: proxyData.userInfo.mac,
          spaceId: proxyData.spaceId,
          // projectId: store.state.user.projectId,
        };
        let paramsStr: any = setQueryConfig(params);
        getDefaultLocation(paramsStr).then((res) => {
          let resData: any = res;
          proxyData.defaultSpaceData = resData?.data ?? {};
          proxyData.checkPositon.buildingId =proxyData.defaultSpaceData.buildingId;
          proxyData.setCheckPersiton();
          proxyData.getBuildingList();
        });
      },
      // 设置选中的位置
      setCheckPersiton() {
        proxyData.checkPositon.buildingId =
          proxyData.defaultSpaceData.buildingId;
        proxyData.checkPositon.floorId = proxyData.defaultSpaceData.floorId;
      },
      // 格式工作办公数据
      formataWorkData() {
        let data: any = proxyData.spaceData.filter((item: any) => {
          return item.checked;
        });
        proxyData.copySpaceData.map((item: any) => {
          for (let i = 0; i < data.length; i++) {
            if (item.spaceId === data[i].spaceId) {
              item.checked = data[i].checked;
            }
          }
        });
        let paramsArr: any = proxyData.copySpaceData.filter((item: any) => {
          return item.checked;
        });
        return paramsArr;
      },
      // 设置主空间
      goNext() {
        proxyGlobal.proxy.$loadingStart(0);
        proxyData.querySpaceList();
      },
      updateWorkSpace(item: any) {
        if (item.checked) {
          proxyData.insertWorkSpace(item);
        } else {
          proxyData.deleteWorkSpace(item);
        }
      },
      insertWorkSpace(item: any, isMajorSpace: any = 0) {
        let params: any = {
          spaceId: item.spaceId, //类型：String  必有字段  备注：工作空间列表
          isMajorSpace: isMajorSpace, //类型：Number  必有字段  备注：是否主空间 0-否 1-是
          macAddress: proxyData.userInfo.mac, //类型：String  必有字段  备注：平板地址
        };
        insertWorkSpace(params).then((res: any) => {});
      },
      deleteWorkSpace(item: any) {
        let params: any = {
          spaceId: item.spaceId, //类型：String  必有字段  备注：工作空间列表
          macAddress: proxyData.userInfo.mac, //类型：String  必有字段  备注：平板地址
        };
        deleteWorkSpace(params).then((res: any) => {});
      },
      // 保存空间
      // saveWorkSpace(params: any) {
      //   proxyGlobal.proxy.$loadingStart(0);
      //   saveWorkSpace(params).then((res) => {
      //     proxyData.querySpaceList();
      //     // router.push({ name: "setMainSpace" });
      //   });
      // },
      querySpaceList() {
        let params: any = {
          criteria: {
            projectId: proxyData.userInfo.projectId,
            //类型：Object  必有字段  备注：无
            macAddress: proxyData.userInfo.mac, //类型：String  必有字段  备注：mac地址
          },
        };
        checkWorkSpace(params)
          .then((res) => {
            let resData: any = res;
            let data: any = [];
            if (resData.result === "success") {
              data = resData?.content ?? [];
            } else {
              data = [];
            }
            if (data.length > 1) {
              // router.push({ name: "setMainSpace" });
              setTimeout(() => {
                proxyGlobal.proxy.$loadinngEnd();
                router.push({ name: "setMainSpace" });
              }, 1000);
            } else if (data.length === 1) {
              proxyData.insertWorkSpace(data[0], 1);
              proxyGlobal.proxy.$loadinngEnd();
              router.push({
                name: "envmonitor",
                query: { spaceId: data[0].spaceId },
              });
            } else {
              Toast("请选择办公空间!");
            }
          })
          .catch(() => {
            proxyGlobal.proxy.$loadinngEnd();
          });
      },
      // 选择建筑
      checkBuilding(index: any) {
        proxyData.checkPositon.buildingId = proxyData.positionArr[index].id;
        proxyData.checkPositon.buildingName = proxyData.positionArr[index].text;
        proxyData.getFloorList();
      },
      // 选择楼层
      checkFloor(item: any) {
        proxyData.checkPositon.floorId = item.id;
        proxyData.checkPositon.floorName = item.localName;
        proxyData.show = false;
        nextTick(() => {
          proxyData.setPageScroolTop();
        });
        proxyData.clearSearchName();
        proxyData.getPadSpaceList();
      },
      // 清除搜索条件
      clearSearchName() {
        proxyData.searchSpaceName = "";
        proxyData.spaceType = spaceType;
        // 清除默认样式
        let spaceContetEl: any = document.querySelector(".choice-space");
        spaceContetEl.scrollTop = 0;
      },
      spaceData: spaceData,
      copySpaceData: copySpaceData,
      nowPerstionIndex: 0,
      // 空间列表
      getPadSpaceList(query: any = "") {
        // debugger;
        let params: any = query
          ? query
          : {
              floorId: proxyData.checkPositon.floorId,
              buildingId: proxyData.checkPositon.buildingId,
              macAddress: proxyData.userInfo.mac,
            };
        let str: any = setQueryConfig(params);
        getPadSpaceList(str).then((res) => {
          let resData: any = res;
          if (resData.result === "success") {
            proxyData.spaceData = resData?.data ?? [];
            proxyData.spaceData.map((item: any, index: any) => {
              if (item.isWorkSpace) {
                item.checked = true;
              } else {
                item.checked = false;
              }
              if (item.spaceId === proxyData.spaceId) {
                item.checked = true;
              }
            });
            // 不搜索的时候数据备份一下
            if (!query) {
              proxyData.copySpaceData = JSON.parse(
                JSON.stringify(proxyData.spaceData)
              );
            }
          } else {
            proxyData.spaceData = [];
          }
          if (proxyData && proxyData.spaceData.length) {
            proxyData.showSpace = true;
          } else {
            proxyData.showSpace = false;
          }
          // 设置页面默认的位置
          nextTick(() => {
            proxyData.setPageScroolTop();
          });
        });
      },
      // 设置当前页面选中的位置
      setPageScroolTop() {
        let idIndex: any = 0;
        // debugger;
        for (let i = 0; i < proxyData.spaceData.length; i++) {
          if (proxyData.spaceData[i].checked) {
            idIndex = i;
            break;
          }
        }
        let spaceEl: any = document.querySelector("#" + "space" + idIndex);
        let spaceContetEl: any = document.querySelector(".choice-space");
        // spaceContetEl.scrollTop = 0;
        let top: any = spaceEl ? spaceEl.offsetTop : 0;
        if (top > 120) {
          top = top - 120;
        } else {
          top = 0;
        }
        if (spaceContetEl) {
          spaceContetEl.scrollTop = top;
        } else {
          spaceContetEl.scrollTop = 0;
        }
      },
      searchSpace() {
        let query: any = {
          floorId: proxyData.checkPositon.floorId,
          buildingId: proxyData.checkPositon.buildingId,
          funcType: proxyData.spaceType.type,
          spaceName: proxyData.searchSpaceName,
          macAddress: proxyData.userInfo.mac,
        };
        proxyData.getPadSpaceList(query);
      },
      spaceId: "",
      init() {
        let spaceId: any = route.query.spaceId;
        proxyData.spaceId = spaceId;
        let projectId: any = route.query.id;
        store.commit(UserMutationTypes.SET_PROJECT_ID, projectId);
        proxyData.getDefaultLocation();
        if (spaceId) {
          let item: any = {
            spaceId: spaceId, //类型：String  必有字段  备注：工作空间列表
          };
          proxyData.insertWorkSpace(item, 0);
        }
      },
    });
    onMounted(() => {
      proxyData.init();
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
